
export const DevicesTableModel = {
  Status: "Status",
  MachineName: "Machine name",
  OperatorId: "Operator ID",
  DeviceID: "Device ID",
  City: "City",
  Address: "Address",
  ConnectivityStatus: "Connectivity status",
  SoftwareVersion: "Software version",
  OperatingStatus: "Operating status",
  Time: "Time"
};

export const CampaignTableModel = {
  Id: "Id",
  CampaignName: "Campaign name",
  ValidFrom: "Valid from",
  ValidTo: "Valid to",
  IssuedVouchers: "Issued Vouchers",
  RedeemedVouchers: "Redeemed Vouchers",
  Scope: "Scopes",
  State: "State"
};

export const BulkTableModel = {
  machineName: "machineName",
  operatorId: "operatorId",
  deviceId: "deviceId",
  address: "address",
  streetNumber: "streetNumber",
  machineGroup: "machineGroup",
  ipAddress: "ipAddress",
  country: "country",
  zipCode: "zipCode",
  city: "city",
  note1: "note1",
  note2: "note2",
  longitude: "longitude",
  latitude: "latitude",
}
export const BulkTableModelTableNames = {
  machineName: "Machine name",
  operatorId: "Operator ID",
  deviceId: "Device ID",
  address: "Address",
  streetNumber: "Street number",
  machineGroup: "machineGroup",
  ipAddress: "Ip Address",
  zipCode: "Zip code",
  country: "Country",
  city: "City",
  note1: "Note1",
  note2: "Note2",
  longitude: "Longitude",
  latitude: "Latitude",
}
export const UserTableModel = {
  id: "id",
  user: "user",
  firstName: "firstName",
  lastName: "lastName",
  merchant: "merchant",
  role: "role",
  username: "username"
}
export const UserTableModelNames = {
  user: "User name",
  firstName: "First name",
  lastName: "Last name",
  merchant: "Merchant/s",
  role: "Role/s"
}